import { twMerge } from "tailwind-merge";
import { useChat } from "../context/ChatContext";
import { useUser } from "../UserContext";
import { useSubMenu } from "../SubMenuContext";
import { useWindowDimensions } from "../lib/hook/copyClipBoard";
import { ActionBarSlot } from "./ActionBar";
import { NotificationAlertAuto } from "./NotificationAlert";

const MOBILE_BREAKPOINT = 460;

const SideBarContentComponent = ({ children }: { children?: React.ReactNode }) => {
    const { isChatOpen } = useChat();
    const { iframe } = useUser();
    const { isSidebarOpen, setSideBarOpen } = useSubMenu();
    const { width } = useWindowDimensions();

    const closeSidebarOnMobile = () => {
        if (width <= MOBILE_BREAKPOINT && isSidebarOpen) setSideBarOpen(false);
    };

    return (
        <div className={twMerge('relative flex flex-col w-full', iframe ? 'h-full' : 'h-[calc(100%-50px)]')}>
            <div onClick={closeSidebarOnMobile} className={twMerge('app-content-empreender-lib w-full overflow-auto overflow-x-hidden relative z-0 bg-white flex-1 min-h-0 custom-scroll', `rounded-tl-xl ${isChatOpen ? 'rounded-tr-xl' : ''}`)}>
                {children}
            </div>

            <NotificationAlertAuto className={`rounded-tl-xl ${isChatOpen ? 'rounded-tr-xl' : ''}`} />

            <ActionBarSlot />
        </div>
    )
};

export default SideBarContentComponent;